export default __webpack_public_path__ + "555f03e263bcbecefef3d8c69cdd6e76.ttf";